<template>
  <b-modal
    id="account-deletion-modal"
    v-model="openModal"
    size="lg"
    :title="$t('profile.accountDeletion.title')"
  >
    <div>
      <div class="alert alert-danger" role="alert">
        {{ $t('profile.accountDeletion.warning') }}
      </div>
      <div class="mb-3">
        <label for="username-check" class="form-label">
          {{ $t('profile.accountDeletion.inputLabel') }}
        </label>
        <input
          v-model="usernameCheck"
          id="username-check"
          class="form-control"
          :class="{
            'is-invalid': !usernameInputValid
          }"
        >
        <div class="invalid-feedback">
          {{ $t('profile.accountDeletion.inputError') }}
        </div>
      </div>
    </div>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="outline-secondary"
          class="float-left"
          @click="openModal = false; $emit('close')"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button
          variant="danger"
          class="float-right"
          :disabled="!usernameCheck"
          @click="checkUsernameInput"
        >
          {{ $t('profile.accountDeletion.delete') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>

import loginAPI from '@/api/loginAPI.js';

export default {
  name: 'AccountDeletionModal',

  props: {
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      openModal: false,
      usernameCheck: null,
      usernameInputValid: true,
    }
  },

  watch: {
    open(newVal) {
      this.usernameCheck = null;
      this.usernameInputValid = true;
      this.openModal = newVal;
    }
  },

  methods: {
    checkUsernameInput() {
      if (this.usernameCheck === loginAPI.userData.username) {
        this.usernameInputValid = true;
        this.$emit('delete');
      } else {
        this.usernameInputValid = false;
      }
    }
  }
}
</script>